var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDePth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 12,
    viewBox: "0 0 57 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.630859 11.3004V0.790039H8.75266C11.6947 0.790039 13.463 2.77342 13.463 6.05301C13.463 9.33261 11.6947 11.3004 8.75266 11.3004H0.630859ZM8.37709 2.41422H2.43049V9.67619H8.37709C10.4271 9.67619 11.7103 8.28626 11.7103 6.05301C11.7103 3.81976 10.4271 2.41422 8.37709 2.41422Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1795 11.3004V0.790039H27.3857V2.41422H16.9791V4.02279H27.2292V5.64697H16.9791V9.67619H27.3857V11.3004H15.1795Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1015 11.4565V0.790039H39.602C41.0573 0.790039 41.9337 1.69583 41.9337 3.2107C41.9337 4.72556 41.0573 5.64697 39.602 5.64697H30.9012V11.4565H29.1015ZM39.1325 2.41422H30.9012V4.02279H39.1325C39.8211 4.02279 40.181 3.77291 40.181 3.2107C40.181 2.64848 39.8054 2.41422 39.1325 2.41422Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2815 6.99798V5.81426H44.2737V3.45819H45.5853V5.81426H47.9576V6.99798H45.5853V9.03536C45.5853 9.58169 45.8248 9.93454 46.532 9.93454H48.0717V11.1183H46.4065C44.8212 11.1183 44.2737 10.3101 44.2737 9.08089V6.99798H43.2815Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8072 6.99798C51.1001 6.99798 50.6325 7.35082 50.6325 7.89716V11.1183H49.3209V3.45819H50.6325V6.22401C50.9062 5.97361 51.2826 5.81426 51.7274 5.81426H54.7155C56.3008 5.81426 56.8483 6.62238 56.8483 7.85163V11.1183H55.5367V7.89716C55.5367 7.35082 55.2972 6.99798 54.5901 6.99798H51.8072Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDePth);
export default __webpack_public_path__ + "static/media/DEPth.e2ac62c73d5ea9dc1da1bd2da86a1517.svg";
export { ForwardRef as ReactComponent };